/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import localforage from 'localforage';

export const storageDb = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
  size: 1e8, // Size of database, in bytes. WebSQL-only for now.
  name: 'flpro_db',
  storeName: 'flpro_persist',
  version: 1.0,
});
